import { z } from "zod";

/** The waiting delivery note an invoice takes by hand, picked on the invoice's own page. */
export const incomingInvoiceDeliveryNotePickSchema = z.object({
	deliveryNoteId: z.string().min(1),
});

export type IncomingInvoiceDeliveryNotePickSchema = z.infer<
	typeof incomingInvoiceDeliveryNotePickSchema
>;
